export const zhCN_system = {
	'app.system.login.username': '用户名',
	'app.system.login.phone': '手机号',
	'app.system.login.password': '密码',
	'app.system.login.pincode': '验证码',
	'app.system.login.privacy': '我同意用户服务协议',
	'app.system.login.registry': '注册',
	'app.system.login.login': '登录',
	'app.system.login.getpincode': '获取验证码',
	'app.system.common': '系统通用',
	'app.system.common.user.center': '用户中心',
	'app.system.common.user.setting': '用户设置',
	'app.system.common.user.logout': '退出登录',
	'app.common.language.chinese': '中文',
	'app.system.common.list': '列表',
	'app.system.common.button.query': '查询',
	'app.system.common.button.create': '新建',
	'app.system.common.button.cancel': '取消',
	'app.system.common.button.reset': '重置',
	'app.system.common.button.detail': '详情',
	'app.system.common.button.edit': '编辑',
	'app.system.common.button.delete': '删除',
	'app.system.common.button.export': '导出',
	'app.system.common.button.copy': '复制',
	'app.system.common.button.more': '更多',
	'app.system.common.button.copyException': '复制异常堆栈',
	'app.system.common.button.exportRow': '导出该条',
	'app.system.common.button.save': '保存',
	'app.system.common.button.refresh': '刷新',
	'app.system.common.button.expand': '展开',
	'app.system.common.button.collapse': '收起',
	'app.system.common.query.like': '模糊查询',
	'app.system.common.input': '请输入',
	'app.system.common.select': '请选择',
	'app.system.common.operator': '操作',
	'app.system.common.create.time': '创建时间',
	'app.system.common.create.operator': '创建人',
	'app.system.common.update.time': '更新时间',
	'app.system.common.update.operator': '更新人',
	'app.system.role': '角色',
	'app.system.role.name': '角色名称',
	'app.system.role.code': '角色编码',
	'app.system.permission': '权限',
	'app.system.permission.name': '权限名称',
	'app.system.permission.code': '权限编码',
	'app.system.dept': '部门',
	'app.system.dept.name': '部门名称',
	'app.system.dept.parent': '上级部门',
	'app.system.account': '账户',
	'app.system.account.nickname': '昵称',
	'app.system.account.name': '登录账户',
	'app.system.account.password': '账户密码',
	'app.system.account.phone': '联系电话',
	'app.system.account.email': '联系邮箱',
	// 通用提示文本
	'app.common.success.create': '新增成功',
	'app.common.success.update': '保存成功',
	'app.common.success.avatar': '头像更新成功',
	'app.common.success.export': '导出成功',
	'app.common.error.export': '导出失败',
	'app.common.loading': '加载中...',
	'app.common.error.select.parent': '请选择一个上级部门',
	'app.common.error.password.required': '账户密码不可为空',
	'app.common.error.nickname.required': '昵称不可为空',
	'app.common.error.dept.required': '所属部门不可为空',
	'app.common.error.roleName.required': '角色名称不可为空',
	'app.common.error.roleCode.required': '角色编码不可为空',
	'app.common.error.permissionName.required': '权限名不可为空',
	'app.common.error.codeType.required': '字典类型不可为空',
	'app.common.error.codeDesc.required': '字典描述不可为空',
	'app.common.error.codeValue.required': '字典值不可为空',
	'app.common.error.noticeTitle.required': '公告标题不可为空',
	'app.common.error.jobName.required': '任务名称不可为空',
	'app.common.error.jobGroup.required': '任务分组不可为空',
	'app.common.error.cronExpression.required': 'Cron 表达式不可为空',
	'app.common.error.invokeTarget.required': '调用目标不可为空',
	'app.system.permission.systemMenu': '系统菜单',
	'app.common.label.permissionList': '权限列表',
	'app.common.label.accountDepts': '账户所属部门',
	'app.common.label.nickname': '昵称',
	'app.common.label.avatar': '头像',
	'app.common.label.email': '邮箱',
	'app.common.label.phone': '电话',
	'app.common.label.profile': '个人简介',
	'app.common.label.oldPassword': '旧密码',
	'app.common.label.newPassword': '新密码',
	'app.common.label.confirmPassword': '确认新密码',
	'app.common.placeholder.nickname': '请输入昵称',
	'app.common.placeholder.email': '请输入邮箱',
	'app.common.placeholder.phone': '请输入电话',
	'app.common.placeholder.profile': '请填写个人简介',
	'app.common.placeholder.oldPassword': '请输入旧密码',
	'app.common.placeholder.newPassword': '请输入新密码',
	'app.common.placeholder.confirmPassword': '请确认新密码',
	'app.common.success.save': '保存成功',
	'app.common.error.save': '保存失败',
	'app.common.error.deptName.required': '部门名称不可为空',
	'app.common.error.role.required': '所属角色不可为空',
	// 通用确认文本
	'app.common.confirm.delete.title': '您确认删除该条数据吗?',
	'app.common.confirm.delete.content': '请确认，删除后无法恢复',
	'app.common.confirm.discard.title': '确认放弃当前编辑?',
	'app.common.confirm.discard.content': '关闭后未保存的修改将丢失',
	'app.common.confirm.execute.title': '您确认手动执行吗？',
	'app.common.confirm.execute.content': '请确认是否立即执行该任务',
	'app.common.confirm.resume.title': '您确认开启该任务吗？',
	'app.common.confirm.resume.content': '请确认是否开启该定时任务',
	'app.common.confirm.pause.title': '您确认关闭该任务吗？',
	'app.common.confirm.pause.content': '请确认是否关闭该定时任务',
	'app.common.success.resume': '开启成功',
	'app.common.success.pause': '关闭成功',
	// 全局搜索
	'app.common.search.placeholder': '搜索...',
	'app.common.search.recent': '最近搜索',
	'app.common.search.empty': '开始输入以搜索',
	'app.common.search.noResult': '未找到匹配项',
	'app.common.search.hint': '↑↓ 导航 · Enter 跳转 · Esc 关闭',
	'app.common.search.hotkey': '⌘K',
	// 账户相关
	'app.system.account.deptName': '部门名称',
	'app.system.account.roleName': '角色名称',
	'app.system.account.lastLoginTime': '最后一次登录时间',
	'app.system.account.accountRoles': '账户所属角色',
	// 用户设置相关
	'app.system.settings.basic': '基础设置',
	'app.system.settings.security': '安全设置',
	'app.system.settings.accountBinding': '账号绑定',
	'app.system.settings.saveBasic': '保存基本信息',
	'app.system.settings.saveSecurity': '保存安全设置',
	// 账号绑定状态
	'app.common.status.bound': '已绑定',
	'app.common.status.unbound': '未绑定',
	'app.common.button.bind': '绑定',
	'app.common.button.unbind': '解绑',
	// 列设置
	'app.system.common.button.columnSetting': '列设置',
	'app.system.common.columnSetting.title': '显示列',
	'app.system.common.columnSetting.checkAll': '全选',
	'app.system.common.columnSetting.reset': '重置',
	// 登录相关
	'app.system.login.usernamePlaceholder': '初始化账号 admin',
	'app.system.login.phonePlaceholder': '默认手机号 15500000000',
	'app.system.login.passwordPlaceholder': '初始化密码 123456',
	'app.system.login.pincodePlaceholder': '初始化验证码 123456',
	'app.system.login.welcome': '欢迎进入系统',
	'app.system.login.or': '或',
	'app.system.login.type': '登录方式',
	'app.system.login.type.account': '账号',
	'app.system.login.type.phone': '手机',
	'app.system.login.type.github': 'GitHub',
	'app.system.login.type.feishu': '飞书',
	'app.system.login.type.wechat': '微信',
	'app.system.login.signInWith': '使用 {provider} 登录',
	'app.system.login.oauthDesc': '点击下方按钮跳转到 {provider} 进行授权',
	'app.system.login.continue': '继续',
	'app.system.login.wechat.scanHint': '打开微信扫一扫',
	'app.system.login.demo.title': '演示账户',
	'app.system.login.demo.hint': '开源演示用 · 点击自动填入',
	'app.system.login.demo.admin': 'Admin',
	'app.system.login.demo.adminDesc': '管理员 · 完整权限',
	'app.system.login.demo.test': 'Test',
	'app.system.login.demo.testDesc': '测试账号 · 部分权限',
	// 工作台相关
	'app.system.workbench.title': '工作台',
	'app.system.workbench.teamRanking': '团队内排名',
	'app.system.workbench.compareYesterday': '较昨天',
	'app.system.workbench.projectAccess': '项目访问',
	'app.system.workbench.greeting': '您好，{name}，祝你开心每一天',
	'app.system.workbench.systemNotice': '系统公告',
	'app.system.workbench.recentActivity': '最近动态',
	'app.system.workbench.more': '更多',
	'app.system.workbench.timeAgo': '7分钟前',
	'app.system.workbench.quickNavigation': '快捷导航',
	'app.system.workbench.operation': '操作',
	'app.system.workbench.add': '添加',
	'app.system.workbench.salesIndex': '销售指数',
	// Config 相关
	'app.config.code.title': '字典管理',
	'app.config.code.detailTitle': '字典详情',
	'app.config.code.table.codeId': '字典ID',
	'app.config.code.table.codeType': '字典类型',
	'app.config.code.table.codeLabel': '字典值',
	'app.config.code.table.codeValue': '字典码',
	'app.config.code.table.codeDesc': '字典描述',
	'app.config.code.label.codeType': '字典类型',
	'app.config.code.label.codeDesc': '字典描述',
	'app.config.code.label.codeValue': '字典码',
	'app.config.code.label.codeLabel': '字典值',
	'app.config.code.placeholder.codeDesc': '请输入字典描述',
	'app.config.menu.title': '菜单管理',
	'app.config.menu.detailTitle': '菜单详情',
	'app.config.menu.table.menuId': '菜单ID',
	'app.config.menu.table.parentMenuId': '父菜单',
	'app.config.menu.table.i18n': 'i18n',
	'app.config.menu.table.iconName': '图标名称',
	'app.config.menu.table.menuPath': '菜单路径',
	'app.config.menu.table.orderNum': '菜单顺序',
	'app.config.menu.table.hiddenMenu': '是否隐藏',
	'app.config.menu.label.parentMenuId': '父菜单',
	'app.config.menu.label.iconName': '图标名称',
	'app.config.menu.label.orderNum': '菜单顺序',
	'app.config.menu.tooltip.parentMenuId': '如果您需要创建一级菜单，选择父菜单为顶级菜单即可',
	'app.config.menu.placeholder.iconName': '请选择菜单图标',
	'app.common.error.orderNum.required': '菜单顺序不可为空',
	'app.common.error.textKey.required': 'i18n key 不可为空',
	'app.config.menu.label.hiddenMenu': '隐藏菜单',
	'app.config.menu.label.i18n': 'i18n',
	'app.config.menu.label.menuPath': '菜单路径',
	'app.config.menu.placeholder.menuPath': '请输入菜单路径',
	'app.config.notice.title': '公告管理',
	'app.config.notice.detailTitle': '公告详情',
	'app.config.notice.table.noticeId': '公告ID',
	'app.config.notice.table.title': '公告标题',
	'app.config.notice.table.content': '公告内容',
	'app.config.notice.label.title': '公告标题',
	'app.config.notice.label.content': '公告内容',
	'app.config.notice.placeholder.content': '请在这里输入公告...',
	'app.config.schedule.title': '批处理管理',
	'app.config.schedule.detailTitle': '批处理详情',
	'app.config.schedule.table.jobName': '任务名称',
	'app.config.schedule.table.jobGroup': '任务分组',
	'app.config.schedule.table.cronExpression': 'cron表达式',
	'app.config.schedule.table.invokeTarget': '任务执行类',
	'app.config.schedule.table.status': '任务状态',
	'app.config.schedule.aria.taskStatus': '是否开启定时任务',
	'app.config.schedule.button.execute': '执行',
	'app.config.schedule.label.jobName': '批处理名称',
	'app.config.schedule.label.jobGroup': '批处理分组',
	'app.config.schedule.label.cronExpression': 'cron表达式',
	'app.config.schedule.label.invokeTarget': '目标执行方法',
	'app.config.schedule.placeholder.jobName': '请输入任务名称',
	// 批处理日志
	'app.config.schedule.button.log': '日志',
	'app.config.schedule.log.table.jobName': '任务名称',
	'app.config.schedule.log.table.jobGroup': '任务分组',
	'app.config.schedule.log.table.startTime': '开始时间',
	'app.config.schedule.log.table.endTime': '结束时间',
	'app.config.schedule.log.table.duration': '耗时',
	'app.config.schedule.log.table.status': '执行状态',
	'app.config.schedule.log.table.exception': '异常堆栈',
	'app.config.schedule.log.table.createTime': '创建时间',
	'app.config.schedule.log.label.jobName': '任务名称',
	'app.config.schedule.log.label.jobGroup': '任务分组',
	'app.config.schedule.log.label.status': '执行状态',
	'app.config.schedule.log.label.time': '执行时间',
	'app.config.schedule.log.placeholder.jobName': '请输入任务名称',
	'app.config.schedule.log.placeholder.jobGroup': '请输入任务分组',
	'app.config.schedule.log.placeholder.status': '请选择执行状态',
	'app.config.schedule.log.placeholder.timeStart': '开始日期',
	'app.config.schedule.log.placeholder.timeEnd': '结束日期',
	'app.config.schedule.log.status.success': '成功',
	'app.config.schedule.log.status.fail': '失败',
	'app.config.schedule.log.button.viewFull': '查看完整',
	'app.config.schedule.log.modal.exception': '异常堆栈',
	// User 相关
	'app.user.center.title': '用户中心',
	// Logs 相关
	'app.logs.title': '日志管理',
	'app.logs.table.logType': '日志类型',
	'app.logs.table.userId': '用户ID',
	'app.logs.table.logContent': '日志内容',
	'app.logs.table.logModule': '日志模块',
	'app.logs.table.logThread': '日志线程',
	'app.logs.table.exception': '异常堆栈',
	'app.logs.table.ip': 'IP',
	'app.logs.label.desc': '日志描述',
	'app.logs.placeholder.desc': '请输入日志描述',
	// 主题设置
	'app.theme.title': '主题设置',
	'app.theme.section.color': '系统主题色',
	'app.theme.section.style': '主题风格',
	'app.theme.section.width': '容器宽度',
	'app.theme.section.basic': '基础配置开关',
	'app.theme.appearanceMode': '界面模式',
	'app.theme.dark': '深色',
	'app.theme.light': '浅色',
	'app.theme.language': '语言',
	'app.theme.comingSoon': '敬请期待',
	'app.theme.hue.blue': '蓝',
	'app.theme.hue.violet': '紫',
	'app.theme.hue.indigo': '靛蓝',
	'app.theme.hue.teal': '青绿',
	'app.theme.hue.amber': '琥珀',
	'app.theme.hue.pink': '玫红',
	'app.theme.section.global': '系统配置',
	'app.theme.section.seo': 'SEO 配置',
	'app.theme.watermark': '全局水印',
	'app.theme.style.system': '跟随系统',
	'app.theme.width.compact': '紧凑',
	'app.theme.width.medium': '中等',
	'app.theme.width.spacious': '舒展',
	'app.theme.systemName': '系统名称',
	'app.theme.copyright': '版权信息',
	'app.theme.siderWidth': '侧边栏宽度',
	'app.theme.seo.title': 'SEO 标题',
	'app.theme.seo.keywords': 'SEO 关键词',
	'app.theme.seo.description': 'SEO 描述',
	// 在线用户
	'app.monitor.online.table.id': '主键',
	'app.monitor.online.table.userId': '用户ID',
	'app.monitor.online.table.username': '登录账户',
	'app.monitor.online.table.loginIp': '登录 IP',
	'app.monitor.online.table.browser': '浏览器',
	'app.monitor.online.table.os': '操作系统',
	'app.monitor.online.table.device': '设备类型',
	'app.monitor.online.table.userAgent': '原始 UA',
	'app.monitor.online.table.token': 'Token',
	'app.monitor.online.table.loginTime': '登录时间',
	'app.monitor.online.table.lastActive': '最后活跃',
	'app.monitor.online.detail.title': '在线用户详情',
	'app.monitor.online.detail.section.basic': '基础信息',
	'app.monitor.online.detail.section.session': '会话信息',
	'app.monitor.online.detail.section.meta': '时间与设备指纹',
	'app.monitor.online.button.kickout': '踢出',
	'app.monitor.online.button.refresh': '刷新',
	'app.monitor.online.confirm.kickout.title': '您确认踢出该用户吗?',
	'app.monitor.online.confirm.kickout.content': '请确认，踢出后该会话将立即失效',
	'app.monitor.online.confirm.kickout.okText': '踢出',
	'app.monitor.online.placeholder.username': '请输入登录账户',
	'app.monitor.online.placeholder.loginIp': '请输入登录 IP',
	// 服务监控
	'app.monitor.server.title': '服务监控',
	'app.monitor.server.runtime': '运行环境',
	'app.monitor.server.usage': '资源使用率',
	'app.monitor.server.cpu': 'CPU 使用率',
	'app.monitor.server.cores': '核心数',
	'app.monitor.server.used': '已用',
	'app.monitor.server.memory': '内存使用率',
	'app.monitor.server.total': '总容量',
	'app.monitor.server.free': '剩余',
	'app.monitor.server.disk': '磁盘使用率',
	'app.monitor.server.jvm': 'JVM 信息',
	'app.monitor.server.jvmName': '名称',
	'app.monitor.server.jvmVersion': '版本',
	'app.monitor.server.jvmHome': 'Home',
	'app.monitor.server.sys': '系统信息',
	'app.monitor.server.osName': '操作系统',
	'app.monitor.server.osArch': '系统架构',
	'app.monitor.server.osVersion': '系统版本',
	'app.monitor.server.hostName': '主机名',
	'app.monitor.server.ipAddress': 'IP 地址',
	'app.monitor.server.uptime': '系统运行时间',
	'app.monitor.server.cache': '缓存监控',
	// 缓存监控（合并到服务监控页中展示）
	'app.monitor.cache.hitRate': '缓存命中率',
	'app.monitor.cache.hits': '命中次数',
	'app.monitor.cache.misses': '未命中',
	'app.monitor.cache.usedMemory': '缓存内存',
	'app.monitor.cache.keyCount': '键数量',
	'app.monitor.cache.used': '已用',
	'app.monitor.cache.total': '总量',
	'app.monitor.cache.size': '键数量',
	'app.monitor.cache.usage': '使用率',
	// 服务监控 —— KPI 简写 & 时序标签
	'app.monitor.server.kpi.cpu': 'CPU',
	'app.monitor.server.kpi.memory': '内存',
	'app.monitor.server.kpi.disk': '磁盘',
	'app.monitor.server.kpi.cache': '缓存',
	'app.monitor.server.trend.recent5min': '最近 5 分钟',
	'app.monitor.server.trend.latest': '当前',
	'app.monitor.server.trend.uptime': '运行时长',
	// 服务监控 —— 饼图分段标签
	'app.monitor.server.pie.used': '已用',
	'app.monitor.server.pie.free': '剩余',
	// 站内信
	'app.message.title': '站内信',
	'app.message.empty': '暂无未读消息',
	'app.message.markAllRead': '全部已读',
	'app.message.viewAll': '查看全部',
	'app.message.scope.all': '全员',
	'app.message.scope.user': '指定用户',
	'app.message.scope.dept': '指定部门',
	'app.message.status.read': '已读',
	'app.message.status.unread': '未读',
	'app.message.tab.list': '消息列表',
	'app.message.tab.create': '发送站内信',
	'app.message.detail.title': '站内信详情',
	'app.message.table.title': '标题',
	'app.message.table.content': '内容预览',
	'app.message.table.scope': '发送范围',
	'app.message.table.sender': '发送人',
	'app.message.table.recipientCount': '收件人',
	'app.message.table.readCount': '已读',
	'app.message.table.read': '阅读状态',
	'app.message.label.title': '站内信标题',
	'app.message.label.scope': '发送范围',
	'app.message.label.recipient': '收件人',
	'app.message.label.recipientDept': '收件部门',
	'app.message.label.content': '站内信内容',
	'app.message.placeholder.title': '请输入站内信标题',
	'app.message.placeholder.titleQuery': '按标题查询',
	'app.message.placeholder.scope': '按发送范围筛选',
	'app.message.placeholder.recipient': '请选择收件人（支持搜索）',
	'app.message.placeholder.recipientDept': '请选择部门',
	'app.message.placeholder.content': '请输入站内信正文...',
	'app.message.error.title.required': '站内信标题不可为空',
	'app.message.error.recipient.required': '请至少选择一个收件人',
	'app.message.error.recipientDept.required': '请至少选择一个部门',
	// AI —— MCP 服务管理
	'app.ai.mcp.title': 'MCP 服务',
	// 查询
	'app.ai.mcp.query.name': '服务名称',
	'app.ai.mcp.query.namePlaceholder': '请输入服务名称',
	'app.ai.mcp.query.protocol': '协议',
	'app.ai.mcp.query.protocolPlaceholder': '请选择协议',
	'app.ai.mcp.query.status': '启用状态',
	'app.ai.mcp.query.statusPlaceholder': '请选择启用状态',
	// 表格列
	'app.ai.mcp.table.id': 'ID',
	'app.ai.mcp.table.name': '服务名称',
	'app.ai.mcp.table.protocol': '协议',
	'app.ai.mcp.table.enabled': '启用状态',
	'app.ai.mcp.table.connStatus': '连接状态',
	'app.ai.mcp.table.target': '连接地址 / 命令',
	'app.ai.mcp.table.lastTest': '最近测试',
	'app.ai.mcp.table.lastCheckTime': '最近测试时间',
	'app.ai.mcp.table.lastCostMs': '耗时',
	'app.ai.mcp.table.updateTime': '更新时间',
	// 协议
	'app.ai.mcp.protocol.sse': 'SSE',
	'app.ai.mcp.protocol.streamableHttp': 'Streamable HTTP',
	'app.ai.mcp.protocol.stdio': 'STDIO',
	'app.ai.mcp.tab.sse': 'SSE',
	'app.ai.mcp.tab.streamableHttp': 'Streamable HTTP',
	'app.ai.mcp.tab.stdio': 'STDIO',
	// 启用状态
	'app.ai.mcp.enabled.on': '已启用',
	'app.ai.mcp.enabled.off': '已禁用',
	// 连接状态
	'app.ai.mcp.conn.connected': '已连接',
	'app.ai.mcp.conn.disconnected': '未连接',
	'app.ai.mcp.conn.unknown': '未知',
	// 按钮
	'app.ai.mcp.button.tools': '工具',
	'app.ai.mcp.button.test': '测试连通性',
	// 删除 / 测试提示
	'app.ai.mcp.confirm.delete.title': '您确认删除该 MCP 服务吗?',
	'app.ai.mcp.confirm.delete.content': '请确认，删除后无法恢复',
	'app.ai.mcp.test.success': '连接成功',
	'app.ai.mcp.test.fail': '连接失败',
	'app.ai.mcp.test.disabledTip': '该服务已禁用，请先启用后再测试',
	// 详情表单
	'app.ai.mcp.detail.createTitle': '新建 MCP 服务',
	'app.ai.mcp.detail.editTitle': '编辑 MCP 服务',
	'app.ai.mcp.detail.viewTitle': 'MCP 服务详情',
	'app.ai.mcp.form.name': '服务名称',
	'app.ai.mcp.form.namePlaceholder': '请输入服务名称',
	'app.ai.mcp.form.description': '描述',
	'app.ai.mcp.form.descriptionPlaceholder': '请输入描述',
	'app.ai.mcp.form.protocol': '协议',
	'app.ai.mcp.form.enabled': '启用',
	// SSE 字段
	'app.ai.mcp.form.sse.url': 'Endpoint URL',
	'app.ai.mcp.form.sse.urlPlaceholder': '请输入 HTTP/HTTPS 地址',
	'app.ai.mcp.form.sse.headers': '请求头',
	'app.ai.mcp.form.sse.timeout': '连接超时（秒）',
	'app.ai.mcp.form.streamableHttp.url': 'Endpoint URL',
	'app.ai.mcp.form.streamableHttp.urlPlaceholder': '请输入 HTTP/HTTPS 地址',
	'app.ai.mcp.form.streamableHttp.headers': '请求头',
	'app.ai.mcp.form.streamableHttp.timeout': '连接超时（秒）',
	// STDIO 字段
	'app.ai.mcp.form.stdio.command': '命令',
	'app.ai.mcp.form.stdio.commandPlaceholder': '请输入启动命令（仅可信命令）',
	'app.ai.mcp.form.stdio.commandSafety': 'STDIO 协议会在服务端执行本地命令，请仅配置可信命令，避免注入风险。',
	'app.ai.mcp.form.stdio.args': '参数',
	'app.ai.mcp.form.stdio.env': '环境变量',
	'app.ai.mcp.form.stdio.cwd': '工作目录',
	'app.ai.mcp.form.stdio.cwdPlaceholder': '请输入工作目录（可选）',
	// 动态键值对
	'app.ai.mcp.kv.key': '键',
	'app.ai.mcp.kv.value': '值',
	'app.ai.mcp.kv.add': '添加',
	'app.ai.mcp.kv.arg': '参数值',
	// 校验
	'app.ai.mcp.error.name.required': '服务名称不可为空',
	'app.ai.mcp.error.name.pattern': '名称仅支持字母、数字、下划线和短横线',
	'app.ai.mcp.error.protocol.required': '请选择协议',
	'app.ai.mcp.error.url.required': 'Endpoint URL 不可为空',
	'app.ai.mcp.error.url.pattern': '请输入合法的 HTTP/HTTPS 地址',
	'app.ai.mcp.error.timeout.range': '连接超时需在 1~120 秒之间',
	'app.ai.mcp.error.command.required': '命令不可为空',
	'app.ai.mcp.error.kv.duplicate': '存在重复的键',
	// 保存前测试提示
	'app.ai.mcp.form.testSavedOnly': '连通性测试仅支持已保存的服务，请先保存后再测试。',
	'app.ai.mcp.form.testButton': '测试连通性',
	// 工具浏览器
	'app.ai.mcp.tools.title': '工具浏览器',
	'app.ai.mcp.tools.listTitle': '工具列表',
	'app.ai.mcp.tools.empty': '暂无可用工具',
	'app.ai.mcp.tools.schemaTitle': '入参 Schema',
	'app.ai.mcp.tools.noSchema': '该工具无入参 Schema',
	'app.ai.mcp.tools.selectHint': '请从左侧选择一个工具',
	'app.ai.mcp.tools.paramsTitle': '调试参数（JSON）',
	'app.ai.mcp.tools.format': '格式化',
	'app.ai.mcp.tools.call': '调用',
	'app.ai.mcp.tools.resultTitle': '调用结果',
	'app.ai.mcp.tools.noResult': '暂无调用结果',
	'app.ai.mcp.tools.error.invalidJson': '参数不是合法的 JSON',
	'app.ai.mcp.tools.error.notObject': '参数顶层必须是一个对象',
	'app.ai.mcp.tools.disabledTip': '该服务已禁用，无法打开工具浏览器',
	// AI —— 模型供应商(OpenAI 兼容)
	'app.ai.llm.providers.title': '模型供应商',
	// 查询
	'app.ai.llm.providers.query.name': '名称',
	'app.ai.llm.providers.query.namePlaceholder': '按名称模糊查询',
	'app.ai.llm.providers.query.provider': '厂商',
	'app.ai.llm.providers.query.providerPlaceholder': '请选择厂商',
	'app.ai.llm.providers.query.status': '连接状态',
	'app.ai.llm.providers.query.statusPlaceholder': '请选择连接状态',
	// 表格列
	'app.ai.llm.providers.table.id': 'ID',
	'app.ai.llm.providers.table.name': '名称',
	'app.ai.llm.providers.table.provider': '厂商',
	'app.ai.llm.providers.table.modelName': '模型',
	'app.ai.llm.providers.table.baseUrl': '请求地址',
	'app.ai.llm.providers.table.enabled': '启用',
	'app.ai.llm.providers.table.connStatus': '连接状态',
	'app.ai.llm.providers.table.lastTest': '最近测试',
	'app.ai.llm.providers.table.lastCheckTime': '最近测试时间',
	'app.ai.llm.providers.table.lastCostMs': '耗时',
	'app.ai.llm.providers.table.updateTime': '更新时间',
	// 厂商
	'app.ai.llm.providers.vendor.anthropic': 'Anthropic',
	'app.ai.llm.providers.vendor.openai': 'OpenAI',
	'app.ai.llm.providers.vendor.deepseek': 'DeepSeek',
	'app.ai.llm.providers.vendor.zai': 'Z.AI',
	'app.ai.llm.providers.vendor.custom': '自定义',
	// 连接状态
	'app.ai.llm.providers.conn.online': '在线',
	'app.ai.llm.providers.conn.offline': '离线',
	'app.ai.llm.providers.conn.unknown': '未知',
	'app.ai.llm.providers.conn.disabled': '已禁用',
	// 启用状态
	'app.ai.llm.providers.enabled.on': '已启用',
	'app.ai.llm.providers.enabled.off': '已禁用',
	// 测试
	'app.ai.llm.providers.test.success': '连通成功',
	'app.ai.llm.providers.test.fail': '连通失败',
	'app.ai.llm.providers.test.disabledTip': '该供应商已禁用，请先启用后再测试',
	// 详情
	'app.ai.llm.providers.detail.createTitle': '新建模型供应商',
	'app.ai.llm.providers.detail.editTitle': '编辑模型供应商',
	'app.ai.llm.providers.detail.viewTitle': '模型供应商详情',
	// 按钮
	'app.ai.llm.providers.button.test': '测试',
	// 删除确认
	'app.ai.llm.providers.confirm.delete.title': '您确认删除该模型供应商吗?',
	'app.ai.llm.providers.confirm.delete.content': '请确认，删除后无法恢复',
	// 详情表单
	'app.ai.llm.providers.form.name': '名称',
	'app.ai.llm.providers.form.namePlaceholder': '请输入唯一别名(全局唯一)',
	'app.ai.llm.providers.form.provider': '厂商',
	'app.ai.llm.providers.form.modelName': '模型名',
	'app.ai.llm.providers.form.modelNamePlaceholder': '请输入模型名(例:claude-sonnet-4.5)',
	'app.ai.llm.providers.form.baseUrl': '请求地址',
	'app.ai.llm.providers.form.baseUrlPlaceholder': '请输入 OpenAI 兼容端点,必须以 /v1 结尾',
	'app.ai.llm.providers.form.apiKeyCipher': 'API KEY',
	'app.ai.llm.providers.form.apiKeyCipherPlaceholder': '请输入 API KEY(明文,服务端 AES 加密后存储)',
	'app.ai.llm.providers.form.apiKeyEdit': '修改',
	'app.ai.llm.providers.form.enabled': '启用',
	'app.ai.llm.providers.form.testButton': '测试',
	// 详情分组标题
	'app.ai.llm.providers.detail.section.basic': '基础信息',
	'app.ai.llm.providers.detail.section.config': '接口配置',
	// 校验
	'app.ai.llm.providers.error.name.required': '名称不可为空',
	'app.ai.llm.providers.error.name.pattern': '名称仅支持字母、数字、下划线和短横线',
	'app.ai.llm.providers.error.provider.required': '请选择厂商',
	'app.ai.llm.providers.error.modelName.required': '模型名不可为空',
	'app.ai.llm.providers.error.baseUrl.required': '请求地址不可为空',
	'app.ai.llm.providers.error.baseUrl.pattern': '请求地址必须以 /v1 结尾',
	'app.ai.llm.providers.error.apiKeyCipher.required': 'API KEY 不可为空',
	// AI —— 训练场
	'app.ai.training.title': '训练场',
	'app.ai.training.desc': '选择模型与 MCP 工具,实时对话',
	'app.ai.training.config.provider': '模型',
	'app.ai.training.config.thinking': '启用思考/推理',
	'app.ai.training.config.providerPlaceholder': '请选择模型',
	'app.ai.training.config.mcp': 'MCP 工具',
	'app.ai.training.config.mcpPlaceholder': '请选择本次会话要注入的 MCP 工具(可多选)',
	'app.ai.training.config.clear': '清空对话',
	'app.ai.training.config.prompt': '系统提示词',
	'app.ai.training.config.promptPlaceholder': '请选择本次会话要注入的系统提示词',
	'app.ai.training.input.placeholder': '输入消息...',
	'app.ai.training.send': '发送',
	'app.ai.training.stop': '停止',
	'app.ai.training.error.noProvider': '请先选择模型',
	'app.ai.training.error.noMessage': '请输入消息',
	'app.ai.training.error.streamError': '连接异常,请稍后重试',
	'app.ai.training.role.user': '你',
	'app.ai.training.role.assistant': '助手',
	'app.ai.training.toolbar.h5Jump': '移动端视图',
	'app.ai.training.toolbar.h5JumpDesc':
		'在新窗口打开 H5 训练场（请按 F12 → 切换设备工具栏 / Ctrl+Shift+M 查看移动端效果）',
	// AI —— 提示词管理
	'app.ai.llm.prompts.title': '提示词',
	// 查询
	'app.ai.llm.prompts.query.name': '名称',
	'app.ai.llm.prompts.query.namePlaceholder': '按名称模糊查询',
	'app.ai.llm.prompts.query.category': '分类',
	'app.ai.llm.prompts.query.categoryPlaceholder': '请选择分类',
	'app.ai.llm.prompts.query.enabled': '启用状态',
	'app.ai.llm.prompts.query.enabledPlaceholder': '请选择启用状态',
	// 表格列
	'app.ai.llm.prompts.table.id': 'ID',
	'app.ai.llm.prompts.table.name': '名称',
	'app.ai.llm.prompts.table.category': '分类',
	'app.ai.llm.prompts.table.description': '描述',
	'app.ai.llm.prompts.table.content': '内容预览',
	'app.ai.llm.prompts.table.enabled': '启用',
	'app.ai.llm.prompts.table.updateTime': '更新时间',
	// 启用状态
	'app.ai.llm.prompts.enabled.on': '已启用',
	'app.ai.llm.prompts.enabled.off': '已禁用',
	// 详情
	'app.ai.llm.prompts.detail.createTitle': '新建提示词',
	'app.ai.llm.prompts.detail.editTitle': '编辑提示词',
	'app.ai.llm.prompts.detail.viewTitle': '提示词详情',
	'app.ai.llm.prompts.detail.section.basic': '基础信息',
	'app.ai.llm.prompts.detail.section.content': '内容',
	// 表单
	'app.ai.llm.prompts.form.name': '名称',
	'app.ai.llm.prompts.form.namePlaceholder': '请输入唯一别名(全局唯一)',
	'app.ai.llm.prompts.form.category': '分类',
	'app.ai.llm.prompts.form.categoryPlaceholder': '请选择或输入分类',
	'app.ai.llm.prompts.form.description': '描述',
	'app.ai.llm.prompts.form.descriptionPlaceholder': '请输入用途/场景说明',
	'app.ai.llm.prompts.form.content': '系统提示词内容',
	'app.ai.llm.prompts.form.contentPlaceholder': '请输入提示词内容(纯文本)',
	'app.ai.llm.prompts.form.enabled': '启用',
	// 校验
	'app.ai.llm.prompts.error.name.required': '名称不可为空',
	'app.ai.llm.prompts.error.name.pattern': '名称仅支持字母、数字、下划线和短横线',
	'app.ai.llm.prompts.error.content.required': '内容不可为空',
	// 训练场下拉
	'app.ai.llm.prompts.option.none': '不使用提示词',
	// 删除确认
	'app.ai.llm.prompts.confirm.delete.title': '您确认删除该提示词吗?',
	'app.ai.llm.prompts.confirm.delete.content': '请确认,删除后无法恢复',
	// H5 — 移动端训练场
	'app.h5.training': 'AI 对话训练场 (H5)',
	'app.h5.training.title': 'AI 对话训练场',
	'app.h5.training.providerPlaceholder': '选择模型',
	'app.h5.training.input.placeholder': '输入消息...',
	'app.h5.training.send': '发送',
	'app.h5.training.stop': '停止',
	'app.h5.training.error.noProvider': '请先选择模型',
	'app.h5.training.error.noMessage': '请输入消息',
	'app.h5.training.error.streamError': '连接异常,请稍后重试',
	'app.h5.training.devtoolsBanner':
		'PC 浏览器中查看移动端效果：请按 F12 打开 DevTools → 点击「切换设备工具栏」图标（Ctrl+Shift+M），选择手机型号后即可模拟移动端。本 Banner 仅 PC 环境显示。'
}
